module.exports = __webpack_public_path__ + "img/photo-01.a94b0b75.png";